var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinorAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.15 11.1383H9.77499V5.82577C9.77499 3.62108 8.14531 1.7992 6.02499 1.49608V0.888268C6.02499 0.542955 5.74531 0.263268 5.39999 0.263268C5.05468 0.263268 4.77499 0.542955 4.77499 0.888268V1.49608C2.65468 1.7992 1.02499 3.62108 1.02499 5.82577V11.1383H0.649994C0.373431 11.1383 0.149994 11.3617 0.149994 11.6383V12.1383C0.149994 12.207 0.206244 12.2633 0.274994 12.2633H3.64999C3.64999 13.2289 4.43437 14.0133 5.39999 14.0133C6.36562 14.0133 7.14999 13.2289 7.14999 12.2633H10.525C10.5937 12.2633 10.65 12.207 10.65 12.1383V11.6383C10.65 11.3617 10.4266 11.1383 10.15 11.1383ZM5.39999 13.0133C4.98593 13.0133 4.64999 12.6773 4.64999 12.2633H6.14999C6.14999 12.6773 5.81406 13.0133 5.39999 13.0133ZM2.14999 11.1383V5.82577C2.14999 4.95702 2.48749 4.14139 3.10156 3.52733C3.71562 2.91327 4.53124 2.57577 5.39999 2.57577C6.26874 2.57577 7.08437 2.91327 7.69843 3.52733C8.31249 4.14139 8.64999 4.95702 8.64999 5.82577V11.1383H2.14999Z",
    fill: "#FA8C16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinorAlarmIcon);
export default __webpack_public_path__ + "static/media/minorAlarmIcon.e0e1cb608f91cb88a1aa6568ebfabd28.svg";
export { ForwardRef as ReactComponent };